import styled from '@emotion/styled';

export const HeaderContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.5rem;
	color: var(--black);
`;
